import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const AlertTriangleIcon: React.FC<IconProps> = ({
  color = theme.palette.warning.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
  isFilled = false,
}) => {
  const icon = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6291 16.9445 15.1496 3.94441c-1.2921-2.59254-5.007-2.59255-6.29922-.00001L2.37086 16.9445c-1.15958 2.3265.54065 5.0556 3.14963 5.0556H18.4795c2.609 0 4.3092-2.7291 3.1496-5.0556ZM12 8.5c.4142 0 .75.33579.75.75v5.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-5.5c0-.41421.3358-.75.75-.75Zm-.7955 7.8295c.211-.211.4971-.3295.7955-.3295s.5845.1185.7955.3295c.211.211.3295.4971.3295.7955s-.1185.5845-.3295.7955c-.211.211-.4971.3295-.7955.3295s-.5845-.1185-.7955-.3295c-.211-.211-.3295-.4971-.3295-.7955s.1185-.5845.3295-.7955Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6291 16.9445 15.1496 3.94441c-1.2921-2.59254-5.007-2.59255-6.29922-.00001L2.37086 16.9445c-1.15958 2.3265.54065 5.0556 3.14963 5.0556H18.4795c2.609 0 4.3092-2.7291 3.1496-5.0556ZM10.2002 4.61109c.7384-1.48145 2.8612-1.48145 3.5996 0l6.4795 13.00011c.6626 1.3294-.3089 2.8889-1.7998 2.8889H5.52049c-1.49085 0-2.46241-1.5595-1.79979-2.8889l6.4795-13.00011ZM12 8.5c.4142 0 .75.33579.75.75v5.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-5.5c0-.41421.3358-.75.75-.75Zm-.7955 7.8295c.211-.211.4971-.3295.7955-.3295s.5845.1185.7955.3295c.211.211.3295.4971.3295.7955s-.1185.5845-.3295.7955c-.211.211-.4971.3295-.7955.3295s-.5845-.1185-.7955-.3295c-.211-.211-.3295-.4971-.3295-.7955s.1185-.5845.3295-.7955Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="AlertTriangleIcon" size={size} viewBox={viewBox} fill="none">
      {icon}
    </SvgWrapper>
  )
}

export default AlertTriangleIcon
